export function buildLiveCoachClientHello({
  questId,
  conversationContextId,
  deviceInfo,
  ttsMode = 'server_pcm',
}) {
  return {
    type: 'client_hello',
    mode: 'live_coach',
    questId,
    conversationContextId,
    deviceInfo,
    ttsMode,
  };
}

export function isLiveCoachQuotaReached({ usageSeconds, limitMinutes }) {
  if (limitMinutes === -1) {
    return false;
  }
  if (typeof usageSeconds !== 'number' || typeof limitMinutes !== 'number') {
    return false;
  }
  return usageSeconds >= limitMinutes * 60;
}

export function upsertLiveCoachAssistantTranscript(entries, { id, text, timestamp = Date.now() }) {
  if (!id || !text) {
    return entries || [];
  }

  const nextEntry = {
    id,
    author: 'agent',
    text,
    timestamp,
  };
  const source = Array.isArray(entries) ? entries : [];
  const existingIndex = source.findIndex((entry) => entry.id === id);
  if (existingIndex === -1) {
    return [...source, nextEntry];
  }
  return source.map((entry, index) => (index === existingIndex ? nextEntry : entry));
}

export function buildLiveCoachFallbackAudioSrc({ mimeType, base64 } = {}) {
  if (!mimeType || !base64) {
    return null;
  }
  return `data:${mimeType};base64,${base64}`;
}

export function isLiveCoachStartupReady({ liveReady, openerServerDone, openerPlaybackDone } = {}) {
  return Boolean(liveReady && openerServerDone && openerPlaybackDone);
}

export function getLiveCoachStartupTimeoutMessage({ clientHelloAck, t } = {}) {
  if (!clientHelloAck) {
    return t?.(
      'liveCoach.handshakeTimeout',
      'Live Coach handshake did not complete. Restart the server and try again.'
    ) || 'Live Coach handshake did not complete. Restart the server and try again.';
  }
  return t?.(
    'liveCoach.readyTimeout',
    'Live Coach did not finish preparing the selected quest. Close and try again.'
  ) || 'Live Coach did not finish preparing the selected quest. Close and try again.';
}

export function isLiveCoachCompletionAction(message, questId) {
  if (!message || message.type !== 'actions' || !Array.isArray(message.actions) || !questId) {
    return false;
  }
  return message.actions.some((action) => (
    action?.type === 'completeWorkout'
    && (!action.input?.questId || action.input.questId === questId)
  ));
}
